import React from 'react'
import cn from 'classnames'
import { useMarketContext } from 'contexts/MarketContext'

import useResponsive from 'hooks/useResponsive'

import styles from './ProfileDetails.module.css'

export default function ProfileDetails({
  children,
  header = undefined,
  compressed = false,
}) {
  const { isMobile } = useResponsive()
  const { showSuggester } = useMarketContext()

  return (
    <div className={styles.wrapper}>
      {header && (
        <header
          className={cn(styles.mediaWrapper, {
            [styles.mediaWrapperCompressed]: compressed,
            [styles.mediaWrapperHasSuggester]: showSuggester && !compressed,
          })}
        >
          {header}
        </header>
      )}

      {isMobile ? (
        <section className={!compressed ? styles.detailsSection : undefined}>
          {children}
        </section>
      ) : (
        children
      )}
    </div>
  )
}
